import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { OrgState, OrgActions } from './types'
import { Organization } from '@depanneo/types'

const initialState: OrgState = {
  organizationId: null,
  name: null,
  email: null,
  addressLine1: null,
  city: null,
  postalCode: null,
  country: null,
  legalSameAsOperational: true,
  legalAddressLine1: null,
  legalAddressLine2: null,
  legalCity: null,
  legalPostalCode: null,
  legalCountry: null,
  billingSameAsLegal: true,
  billingLegalName: null,
  billingAddressLine1: null,
  billingCity: null,
  billingPostalCode: null,
  billingCountry: null,
  billingSiren: null,
  billingVatNumber: null,
  billingEntityTypes: null,
  billingEntities: [],
  invoiceUserId: null,
  invoiceContactName: null,
  invoiceContactEmail: null,
  invoiceContactPhone: null,
  paymentDelay: null,
  siren: null,
  vatNumber: null,
  legalName: null,
}

export const useOrgStore = create<OrgState & OrgActions>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setOrg: (org: Organization) => {
          set({
            organizationId: org.id,
            ...org,
            paymentDelay: org.paymentDelay?.toString() ?? null,
          })
        },
        setOrgId: (organizationId) => {
          set({ organizationId })
        },
        reset: () => {
          set(initialState)
        },
      }),
      {
        name: 'active-org-storage',
        partialize: (state) => ({
          organizationId: state.organizationId,
        }),
      }
    ),
    { name: 'OrgStore' }
  )
)
